/* unplugin-vue-components disabled */import { render } from "./mobile-header.vue?vue&type=template&id=0a77acc4&scoped=true&ts=true"
import script from "./mobile-header.vue?vue&type=script&lang=ts"
export * from "./mobile-header.vue?vue&type=script&lang=ts"

import "./mobile-header.vue?vue&type=style&index=0&id=0a77acc4&lang=less&scoped=true"
import "./mobile-header.vue?vue&type=style&index=1&id=0a77acc4&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a77acc4"]])

export default __exports__